import {
	useMutation,
	UseMutationResult,
	useQueryClient
} from '@tanstack/react-query';
import { HttpResponseSuccess } from '@/services/service';
import {
	generateAiSequence,
	AI_SEQUENCE_QUERY_KEY,
	AiSequencePayload,
	AiSequenceResponse
} from '@/services/aiSequenceService';

export type { AiSequenceResponse, AiSequencePayload };
export { AI_SEQUENCE_QUERY_KEY };

export const useCreateAiSequence = (): UseMutationResult<
	HttpResponseSuccess<AiSequenceResponse>,
	Error,
	AiSequencePayload
> => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: generateAiSequence,
		onSuccess: responseData => {
			queryClient.setQueryData(AI_SEQUENCE_QUERY_KEY, responseData);
		},
		onError: error => {
			throw new Error('Error creating AI sequence:', error);
		}
	});
};
